import { render, staticRenderFns } from "./applicationUsersSidebar.vue?vue&type=template&id=d0352ef2&scoped=true"
import script from "./applicationUsersSidebar.vue?vue&type=script&lang=js"
export * from "./applicationUsersSidebar.vue?vue&type=script&lang=js"
import style0 from "./applicationUsersSidebar.vue?vue&type=style&index=0&id=d0352ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0352ef2",
  null
  
)

export default component.exports